import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import awsImage from '../../../assets/images/AWS Image.webp';

const certificates = [
  {
    title: 'AWS Academy Graduate - Cloud Foundations ',
    issuedBy: 'Amazon Web Services (AWS)',
    date: '27 October 2025',
    image: awsImage,
    link: 'https://drive.google.com/file/d/1nJnvta7HTe7S89-YA0kbVbITCBkafn75/view?usp=sharing',
  },
];

const AwsCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="AWS"
      certificates={certificates}
    />
  );
};

export default AwsCertificates;
